'use strict';

var React = require('react');
var ReactDOM = require('react-dom');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./cms-bar.scss');
}

var CMSBar = React.createClass({
    render: function() {
        if (typeof document === 'undefined')
            return null;
            
        return document.cookie.match('(^|;) ?DISABLE_GA=([^;]*)(;|$)') && (
            <div className='cms-bar'>
                <a href={`//${Payload.release.moodboard_host}/mood-board`} className='cms-bar-button' >
                    Switch to Mood Board
                </a>
            </div>
        );
    }
});

module.exports = CMSBar;



// WEBPACK FOOTER //
// ./src/components/cms-bar.jsx